import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWatchLater = props => /*#__PURE__*/_jsx("svg", {
  viewBox: "0 0 24 24",
  width: "1em",
  height: "1em",
  ...props,
  children: /*#__PURE__*/_jsx("path", {
    fill: "currentColor",
    d: "M12 1C5.924 1 1 5.924 1 12s4.924 11 11 11 11-4.925 11-11S18.075 1 12 1zm.76 12.345c-.001.028-.006.057-.01.087-.002.022-.004.044-.008.065l-.02.066a.732.732 0 01-.028.079c-.003.004-.003.009-.006.014a.713.713 0 01-.057.1l-.004.005a.682.682 0 01-.08.097l-.026.024a.544.544 0 01-.08.066c-.009.005-.017.013-.027.018a.694.694 0 01-.115.062c-.008.004-.017.005-.026.009a.841.841 0 01-.278.053c-.01 0-.018-.003-.027-.004a.736.736 0 01-.13-.014c-.013-.003-.026-.009-.038-.012a.988.988 0 01-.115-.039c-.004-.003-.008-.003-.013-.004l-4.218-1.99a.761.761 0 01.649-1.376l3.132 1.477V5.563a.76.76 0 111.522 0v7.766c.004.007.003.011.003.016z"
  })
});
export default SvgWatchLater;